// extracted by mini-css-extract-plugin
export var bannerImage = "companies-and-associations-module--bannerImage--sQJqV";
export var backgroundGreen = "companies-and-associations-module--backgroundGreen--3ttq7";
export var backgroundWhite = "companies-and-associations-module--backgroundWhite--1F-ng";
export var backgroundDarkBlue = "companies-and-associations-module--backgroundDarkBlue--KACQM";
export var textWhite = "companies-and-associations-module--textWhite--CSAe2";
export var textDarkblue = "companies-and-associations-module--textDarkblue--2m8Gj";
export var textCenter = "companies-and-associations-module--textCenter--gHOzj";
export var textBlack = "companies-and-associations-module--textBlack--2aehJ";
export var alignCenter = "companies-and-associations-module--alignCenter--2Gs3d";
export var twoColGrid = "companies-and-associations-module--twoColGrid--29Rid";
export var inner = "companies-and-associations-module--inner--3IqsJ";
export var subheading = "companies-and-associations-module--subheading--1Safd";
export var ctaBlock = "companies-and-associations-module--ctaBlock--3pd2j";
export var anchor = "companies-and-associations-module--anchor--3I9Ey";
export var gridBlock = "companies-and-associations-module--gridBlock--1jnfz";
export var paragraph = "companies-and-associations-module--paragraph--2FoYH";
export var spacingTop = "companies-and-associations-module--spacingTop--33LRS";
export var raddningsverket = "companies-and-associations-module--raddningsverket--1KyUY";
export var staticImage = "companies-and-associations-module--staticImage--34k7J";
export var grid = "companies-and-associations-module--grid--1UBK1";
export var list = "companies-and-associations-module--list--2MpIS";
export var sectionPaddingTop = "companies-and-associations-module--sectionPaddingTop--23liL";
export var sectionPaddingBottom = "companies-and-associations-module--sectionPaddingBottom--24fkG";
export var subheadingShort = "companies-and-associations-module--subheadingShort--u_So7";
export var paragraphSmall = "companies-and-associations-module--paragraphSmall--29VGi";
export var paragraphShort = "companies-and-associations-module--paragraphShort--1fGIf";
export var layer = "companies-and-associations-module--layer--2Kr5N";